import { PaginatedResponse } from '@gorila-shared-ui/components';
import { atom, selector, selectorFamily } from 'recoil';
import { Convoy, ConvoyCore } from '../types/convoy';
import { apiParamsState } from './app';

export const loadingConvoysState = atom({
  key: 'app.client.convoys.loading',
  default: false,
});

export const convoysState = atom<PaginatedResponse<Convoy> | undefined>({
  key: 'app.client.convoys',
  default: undefined,
});

export const searchConvoyState = atom<string | undefined>({
  key: 'app.client.convoys.search',
  default: undefined,
});

export const convoysPageState = atom({
  key: 'app.client.convoys.page',
  default: 1,
});

export const selectedConvoyIdState = atom<string | undefined>({
  key: 'app.client.convoys.selectedId',
  default: undefined,
});

export const showConvoyEvaluationsState = atom<boolean>({
  key: 'app.client.convoys.showEvaluations',
  default: false,
});

export const selectedConvoyState = selector({
  key: 'app.client.convoys.selected',
  get: ({ get }) => {
    const selectedConvoyId = get(selectedConvoyIdState);
    if (!selectedConvoyId) return;
    return get(convoyState(selectedConvoyId));
  },
});

export const convoyState = selectorFamily<Convoy | undefined, string>({
  key: 'app.client.convoy',
  get:
    (id) =>
    ({ get }) => {
      const convoys = get(convoysState);
      if (!convoys) return;
      return convoys.items.find((convoy) => convoy._id === id);
    },
});

export const editingConvoyState = atom<ConvoyCore | undefined>({
  key: 'app.client.convoys.editing',
  default: selector({
    key: 'app.client.convoys.editing.initializer',
    get: ({ get }) => {
      const selectedConvoyId = get(selectedConvoyIdState);
      if (selectedConvoyId === undefined) return;
      if (selectedConvoyId === '') {
        const apiParams = get(apiParamsState);
        if (!apiParams) return;
        return {
          _id: '',
          client: apiParams.clientId,
          subClient: apiParams.subClientId,
          active: true,
          startDate: null,
          endDate: null,
          name: '',
          assignedAssets: [],
          separationDistance: 0,
        };
      }
      return get(convoyState(selectedConvoyId));
    },
  }),
});

export const convoyIdsState = selector<string[] | undefined>({
  key: 'app.client.convoyIds.filtered',
  get: ({ get }) => {
    const convoys = get(convoysState);
    if (!convoys) return;

    return convoys.items.map((convoy) => convoy._id);
  },
});

export const updateConvoysState = atom<string | undefined>({
  key: 'app.client.convoys.update',
  default: undefined,
});
